export const Logo = ({
  className = "",
  width = "120",
  height = "120",
}: {
  className?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 225 225"
      className={className}
      aria-label="sooo.dev logo"
    >
      <style>
        {`
          .code-text {
            font-family: monospace;
            font-weight: bold;
          }
          .text-primary {
            fill: hsl(var(--primary));
          }
        `}
      </style>

      <defs>
        <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      <g filter="url(#glow)">
        {/* Left bracket */}
        <text
          x="5"
          y="125"
          className="code-text text-primary"
          style={{ fontSize: "64px" }}
        >
          &lt;
        </text>
        {/* sooo text (first line) */}
        <text
          x="100"
          y="96"
          textAnchor="middle"
          className="code-text text-primary"
          style={{ fontSize: "42px" }}
        >
          sooo
        </text>
        <text
          x="58"
          y="135"
          textAnchor="middle"
          className="code-text text-primary"
          style={{ fontSize: "64px" }}
        >
          .
        </text>
        {/* dev text (second line) */}
        <text
          x="105"
          y="135"
          textAnchor="middle"
          className="code-text text-primary"
          style={{ fontSize: "42px" }}
        >
          dev
        </text>
        {/* Right bracket */}
        <text
          x="145"
          y="125"
          className="code-text text-primary"
          style={{ fontSize: "64px" }}
        >
          /&gt;
        </text>
      </g>
    </svg>
  );
};
